import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DocumentMeta from "react-document-meta";

import Layout from "../Layout";
import { H2RHeading, H2RInput } from "../imports";
import { cuesApi } from "../imports";
import { H2RButton } from "../imports";
import { ReplaceWithDataSource } from "./helpers/variable";
import { faCheck, faMinus, faPlus, faRefresh } from "@fortawesome/free-solid-svg-icons";
import Draggable from "react-draggable";

const itemsDefault = {
  123: {
      type: "string",
      label: "",
      description: "",
      default: "AWAY",
      gddType: "multi-line",
      styles: {
        backgroundColor: 'red',
        bottom: '40px',
        paddingLeft: '10px',
        paddingRight: '10px',
      }
  },
  678: {
      type: "string",
      label: "",
      description: "",
      default: "HOME",
      gddType: "multi-line",
      styles: {
        backgroundColor: 'blue',
        bottom: '10px',
        paddingLeft: '10px',
        paddingRight: '10px',
      }
  },
}

export default function Build() {
	let { projectId } = useParams();
  const [items, setItems] = useState(itemsDefault)
  const [selectedItems, setSelectedItems] = useState([])

  const canvasRef = useRef()

	const selectedProject = useSelector(
		(state) => state.main.projects?.[projectId]
	);

	const meta = {
		title: `Build - ${selectedProject?.name}`,
	};

  const updateItem = (id, key, change) => {
    setItems({
      ...items,
      [id]: {
        ...items[id],
        [key]: change
      }
    })
  }

  const updateStyles = (id, key, change) => {
    setItems({
      ...items,
      [id]: {
        ...items[id],
        styles: {
          ...items[id].styles,
          [key]: change
        }
      }
    })
  }
  console.log(items)

  const onWindowResize = (e) => {
    const canvasWidth = canvasRef.current.offsetWidth
    console.log(canvasWidth, canvasWidth / 1920 * 100)
  }

  useEffect(()=>{
    window.addEventListener('resize', onWindowResize)

    return () => window.removeEventListener('resize', onWindowResize)
  }, [])

	if (selectedProject === undefined) {
		return null;
	} else {
		return (
			<DocumentMeta {...meta}>
				<Layout>
					<section className={`mx-5 my-5 flex flex-col flex-1 overflow-auto`}>
            {/* TOP LEVEL */}
            <p>Build</p>
						<div className="flex">
              <div
                ref={canvasRef}
                className="relative bg-gray-700 aspect-video w-2/3"
              >
                {/* CANVAS */}
                  {Object.entries(items).map(([id, item])=>{
                    return (
                      <Draggable
                      // axis="x"
                      // handle=".handle"
                      defaultPosition={{x: 0, y: 0}}
                      position={null}
                      scale={1}
                      onStart={()=>{}}
                      onDrag={()=>{}}
                      onStop={()=>{}}
                      bounds={'parent'}
                      >
                        <div
                          onClick={()=> setSelectedItems(id)}
                          className={[
                          'w-min hover:ring ring-blue-600 cursor-pointer ring-offset-1 ring-offset-gray-700',
                          selectedItems.includes(id) ? 'ring ring-blue-500 ' : ''
                        ].join(' ')}
                        style={{...item.styles}}
                        >{item.default}</div>
                      </Draggable>
                      // <div
                      //   className={[
                      //     'absolute hover:ring ring-blue-600 cursor-pointer',
                      //     selectedItems.includes(id) ? 'ring ring-offset-1 ring-blue-500 ring-offset-gray-700' : ''
                      //   ].join(' ')}
                      //   draggable
                      //   onDrag={(e)=>{
                      //     const startX = e.clientX
                      //     const 
                      //     console.log(e)
                      //   }
                      //   }
                      //   onClick={()=> setSelectedItems(id)}
                      //   style={{...item.styles}}
                      // >
                        
                      // </div>
                    )
                  })}
              </div>

              <div className="bg-gray-800 w-1/3">
                {Object.entries(items).map(([id, item])=>{
                  if(!selectedItems.includes(id)) return null
                    return (
                      <div>
                        {id}
                        <H2RInput
                          value={item.default}
                          onChange={(change) => updateItem(id, 'default', change)}
                        />
                        <H2RInput
                          type="number"
                          min={-100}
                          max={100}
                          value={item.styles.bottom.split('px')[0] || 0}
                          onChange={(change) => updateStyles(id, 'bottom', `${change}px`)}
                        />
                        <H2RInput
                          type="number"
                          min={-100}
                          max={100}
                          value={item.styles?.left?.split('px')[0] || 0}
                          onChange={(change) => updateStyles(id, 'left', `${change}px`)}
                        />
                        <H2RInput
                          label="BG"
                          colourPicker={true}
                          value={item.styles?.backgroundColor || '#333333'}
                          onChange={(change) => updateStyles(id, 'backgroundColor', change)}
                        />
                        <H2RInput
                          label="Text"
                          colourPicker={true}
                          value={item.styles?.color || '#FFF'}
                          onChange={(change) => updateStyles(id, 'color', change)}
                        />
                      </div>
                    )
                  })}
              </div>
            </div>
					</section>
				</Layout>
			</DocumentMeta>
		);
	}
}
